import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { PagesService } from '../services/pages.service';
import { MarketingService } from '../services/marketing.service';
import { CommonModule } from '@angular/common';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { IMarketing } from '../models/Marketing';


@Component({
    selector: 'app-thankyou-view',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.css']
})
export class ThankYouComponent implements OnInit {

    model: any = {};
    loading = false;
    branchphone: string;
    returnUrl: string;


    constructor(private route: ActivatedRoute,
                private router: Router,
                private authenticationService: AuthenticationService,
                private marketigService: MarketingService,
                private pagesService: PagesService) { }


    ngOnInit() {

   //  const appid =  localStorage.getItem('id');

     const appInfo = this.authenticationService.dataModel;



     let id = '';


     if (appInfo !== null && appInfo !== undefined) {

    localStorage.setItem('appID', appInfo.id);
    id = appInfo.id;
        } else {

            id = localStorage.getItem('appID');
        }



     this.pagesService.getOfficeNumber(id).subscribe((retval) => {

            this.loading = false;
            this.branchphone = retval[0].branchPhone === 'No Number' ? '914-428-7722' : retval[0].branchPhone;
           // this.authenticationService.logout();

          });



     const eventData: IMarketing = this.marketigService.setEventData(
            'PageView',
            `new-premier-pageview`,
            'Page View',
          );
     this.marketigService.onEventFacebook(eventData);


     const eventData1: IMarketing = this.marketigService.setEventData(
        'CompleteRegistration',
        `new-premier-comp register`,
        'Complete Registration',
      );
     this.marketigService.onEventFacebook(eventData1);


     const eventData2: IMarketing = this.marketigService.setEventData(
        'SubmitApplication',
        `new-premier-sub app`,
        'Submit Application',
      );
     this.marketigService.onEventFacebook(eventData2);

    }

}
